(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aromely-guide-carlos"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-agu-root]');
  if (!root) return;
  var links = Array.prototype.slice.call(root.querySelectorAll('[data-agu-link]'));
  var steps = Array.prototype.slice.call(root.querySelectorAll('[data-agu-step]'));
  var rail = root.querySelector('[data-agu-rail]');
  function setCurrent(anchor) {
    links.forEach(function (a) {
      var on = a.getAttribute('data-agu-link') === anchor;
      if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      if (on && rail && window.innerWidth < 900) {
        var r = a.getBoundingClientRect(), rr = rail.getBoundingClientRect();
        if (r.left < rr.left || r.right > rr.right) rail.scrollTo({ left: a.offsetLeft - 16, behavior: 'smooth' });
      }
    });
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var line = 160, cur = steps[0];
      steps.forEach(function (s) { if (s.getBoundingClientRect().top <= line) cur = s; });
      if (cur) setCurrent(cur.getAttribute('data-agu-step'));
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  root.querySelectorAll('[data-agu-copy]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var url = location.origin + location.pathname + a.getAttribute('href');
      if (navigator.clipboard && navigator.clipboard.writeText) {
        e.preventDefault();
        navigator.clipboard.writeText(url).then(function () {
          var s = a.querySelector('span'); if (!s) return;
          var old = s.textContent; s.textContent = 'Copied'; setTimeout(function () { s.textContent = old; }, 1500);
          var st = root.querySelector('[data-agu-copy-status]'); if (st) { st.textContent = ''; setTimeout(function () { st.textContent = 'Link to “' + (a.getAttribute('data-agu-copy-name') || 'this step') + '” copied'; }, 50); }
          history.replaceState(null, '', a.getAttribute('href'));
        }).catch(function () { location.hash = a.getAttribute('href'); });
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
